// Client-side photo quality heuristics: brightness (mean luma) and sharpness (Laplacian variance).
export async function analyzePhoto(file, maxSide = 640) {
  if (!file || !file.type?.startsWith("image/")) return null;
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = url; });
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const w = Math.max(1, Math.round(img.width * scale)), h = Math.max(1, Math.round(img.height * scale));
    const c = document.createElement("canvas"); c.width = w; c.height = h;
    const ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    const { data } = ctx.getImageData(0, 0, w, h);
    const gray = new Float32Array(w * h);
    let sum = 0;
    for (let i = 0, p = 0; i < data.length; i += 4, p++) { const g = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]; gray[p] = g; sum += g; }
    const brightness = sum / (w * h);
    let lapSum = 0, lapSq = 0, n = 0;
    for (let y = 1; y < h - 1; y++) for (let x = 1; x < w - 1; x++) {
      const i = y * w + x;
      const v = 4 * gray[i] - gray[i - 1] - gray[i + 1] - gray[i - w] - gray[i + w];
      lapSum += v; lapSq += v * v; n++;
    }
    const mean = lapSum / n;
    const sharpness = lapSq / n - mean * mean;
    const issues = [];
    if (brightness < 60) issues.push("too dark");
    else if (brightness > 215) issues.push("too bright / washed out");
    if (sharpness < 120) issues.push("blurry");
    return { brightness: Math.round(brightness), sharpness: Math.round(sharpness), issues, ok: issues.length === 0 };
  } catch { return null; }
  finally { URL.revokeObjectURL(url); }
}
